import Main from './components/Module.vue'
import List from './components/ModuleList.vue'
import Form from './components/ModuleForm.vue'
import Show from './components/ModuleShow.vue'

export default [
    {
        path: '/businessArea/:businessAreaId/:systemId/:systemVersion/:formId', component: Main,
        children: [
            {path: '', component: List, name: 'ModuleList'},
            {path: 'create', component: Form, name: 'ModuleCreate'},
            {path: 'edit/:id', component: Form, name: 'ModuleEdit'},
            {path: 'show/:id', component: Show, name: 'ModuleShow'}
        ]
    }
]



// WEBPACK FOOTER //
// ./src/app/module/routes.js